import API_BASE from "../config";
import AuthService from "./auth.service";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api";

// --- Admin: shop table CRUD ---
const getTables = () => axios.get(`${API_URL}/tables`, { headers: authHeader() });
const getTable = (id) => axios.get(`${API_URL}/tables/${id}`, { headers: authHeader() });
const createTable = (data) => axios.post(`${API_URL}/tables`, data, { headers: authHeader() });
const updateTable = (id, data) => axios.put(`${API_URL}/tables/${id}`, data, { headers: authHeader() });
const reorderTables = (ids) => axios.put(`${API_URL}/tables/reorder`, { ids }, { headers: authHeader() });
const removeTable = (id) => axios.delete(`${API_URL}/tables/${id}`, { headers: authHeader() });

// --- Public ordering (no auth) ---
const getPublicTable = (tableId) => axios.get(`${API_URL}/order-by-table/${encodeURIComponent(tableId)}`);
// Sends the token when logged in so the server records who placed the order.
// Expired/stale tokens are not sent, so guests always stay anonymous.
const placeOrder = (tableId, payload) =>
  axios.post(`${API_URL}/order-by-table/${encodeURIComponent(tableId)}`, payload, {
    headers: AuthService.getCurrentUser() ? authHeader() : {},
  });

// --- Staff: table order management ---
// opts.silent: background refresh (no global loading bar).
const getOrders = (params = {}, opts = {}) =>
  axios.get(`${API_URL}/table-orders`, { params, headers: authHeader(), silent: !!opts.silent });
const updateOrderStatus = (id, status) =>
  axios.put(`${API_URL}/table-orders/${id}/status`, { status }, { headers: authHeader() });

const TableService = {
  getTables, getTable, createTable, updateTable, removeTable, reorderTables,
  getPublicTable, placeOrder,
  getOrders, updateOrderStatus,
};

export default TableService;
